// extracted by mini-css-extract-plugin
module.exports = {"iBolit":"He8Ua","logoone":"NRRyJ","patient":"_2TNf8","fader":"_2Jncc","pulse":"_1UX07","logotwo":"SM6JC"};